import React from "react";

const AgentListItem = ({ agent, isSelected, onClick }) => {
  const websites = agent.websites || [];
  const websiteLabel =
    websites.length === 0
      ? "No websites"
      : websites.length === 1
        ? websites[0].website_name || websites[0].website_id
        : `${websites.length} websites`;

  return (
    <div
      onClick={onClick}
      className={`px-4 py-3 border-b border-border-subtle cursor-pointer transition-all ${
        isSelected
          ? "bg-accent-purple/5 border-l-[3px] border-l-accent-purple"
          : "border-l-[3px] border-l-transparent hover:bg-surface-neutral"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <h3 className="text-body-sm font-semibold truncate text-text-primary">
            {agent.title}
          </h3>
          <p className="text-body-xs text-text-tertiary truncate mt-0.5">
            {agent.slug}
          </p>
        </div>
        <span className="shrink-0 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-amber-100 text-amber-800">
          Just for you
        </span>
      </div>
      <div className="flex items-center gap-1.5 mt-2 flex-wrap">
        <span className="text-caption text-text-tertiary truncate max-w-full">
          {websiteLabel}
        </span>
        {agent.runtime_agent_id && (
          <span className="text-caption px-1.5 py-0.5 rounded bg-surface-neutral text-text-secondary">
            runtime
          </span>
        )}
        {!agent.runtime_agent_id && agent.launch_prompt && (
          <span className="text-caption px-1.5 py-0.5 rounded bg-surface-neutral text-text-secondary">
            custom skill
          </span>
        )}
      </div>
    </div>
  );
};

export default AgentListItem;
